import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    changeLayout,
    changeLayoutWidth,
    changeLayoutPosition,
    changelayoutMode,
    changeTopbarTheme,
    changeSidebarType,
    changeSidebarTheme,
} from "../slices/Layout/thunk";
import { useAgency } from 'src/components/Common/agencyBrandingData';


export const useThemeInitializer = () => {
  const dispatch = useDispatch();
  const agency = useAgency(); // Custom hook to get agency data

  useEffect(() => {
    if (agency?.data) {
      dispatch(changelayoutMode(agency.data.layout_theme || 'light' ));
      dispatch(changeTopbarTheme(agency.data.topbar_theme || 'light'));
      
      // Persist to localStorage
      localStorage.setItem("agencyInfo", JSON.stringify({
        data: {
          ...agency.data,
          layout_theme: agency.data.layout_theme || 'light',
          topbar_theme: agency.data.topbar_theme || 'light'
        }
      }));
    }
  }, [agency?.data, dispatch]);
};